import gql from "graphql-tag";

export const folderWithElementsFragment = gql`
  fragment GetFolderElementsFragment on Folder {
    elements {
      id
      content {
        id
        title
      }
    }
  }
`;

export const kurssloeyfeWithElementsFragment = gql`
  fragment GetKurssloeyfeElementsFragment on Kurssloeyfe {
    elements {
      id
      content {
        id
      }
    }
  }
`;
